import './style.scss'

interface ISsrSection {
  ssrData: any[];
}

const SsrSection: React.FC<ISsrSection> = ({ ssrData }) => {
  return (
    <div className="ssr-section-wrapper flex gap-2 w-100 max-h-[40vh]">
      <div className="paid-ssr-section-wrapper w-full border-1 rounded-md p-3 flex flex-col gap-4 overflow-auto">
        <span className="text-xl font-medium text-[#3a3a3a] text-center">Special Services</span>
        <div className="paid-ssr-items-wrapper flex flex-col gap-2.5">
          {ssrData?.map((ssrItem, index) => {
            return (
                <div key={index} className="ssr-input-item-wrapper border-1 px-2.5 py-2">
                  <span className="flex gap-2 items-center w-100">
                    <div key={ssrItem?.specialRequestId} className="paid-ssr-item-wrapper flex justify-between w-100">
                        <span className="text-base font-medium text-[#3a3a3a]">{ssrItem?.name}</span>
                        {ssrItem?.status && <span className="text-xs font-semibold bg-[#FFF3CD] px-2 py-1 border-1 border-[#FFEBAF] rounded-md">STATUS: { ssrItem?.status.replace(/^FOC_|_FOC$/g, "") }</span>}
                      <span className="text-base font-medium text-[#3a3a3a]">₹{ssrItem?.price}</span>
                    </div>
                  </span>
                </div>
            );
          })}
          {ssrData?.map((ssrItem, index) => {
            return (
                <div key={index} className="ssr-input-item-wrapper border-1 px-2.5 py-2">
                  <span className="flex gap-2 items-center w-100">
                    <div key={ssrItem?.specialRequestId} className="paid-ssr-item-wrapper flex justify-between w-100">
                        <span className="text-base font-medium text-[#3a3a3a]">{ssrItem?.name}</span>
                        {ssrItem?.status && <span className="text-xs font-semibold bg-[#FFF3CD] px-2 py-1 border-1 border-[#FFEBAF] rounded-md">STATUS: { ssrItem?.status.replace(/^FOC_|_FOC$/g, "") }</span>}
                      <span className="text-base font-medium text-[#3a3a3a]">₹{ssrItem?.price}</span>
                    </div>
                  </span>
                </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SsrSection;
